import React from 'react';
import { injectIntl, defineMessages, FormattedMessage } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Api from '../../Api/Api';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { CircularProgress } from '@material-ui/core';

const messages = defineMessages({
  infoTitle: {
    id: 'InfoEmployeeDetail.infoTitle',
    defaultMessage: 'Employee information'
  },
  verifiedEmployee: {
    id: 'InfoEmployeeDetail.verifiedEmployee',
    defaultMessage: 'Verified Employee'
  },
  notVerifiedEmployee: {
    id: 'InfoEmployeeDetail.notVerifiedEmployee',
    defaultMessage: 'Self declared employee'
  },
  employeeId: {
    id: 'InfoEmployeeDetail.employeeId',
    defaultMessage: 'Employee ID:'
  },
  email: {
    id: 'InfoEmployeeDetail.email',
    defaultMessage: 'E-mail:'
  }
});

const useStyles = (theme) => ({
  infoIcon: {
    marginRight: theme.spacing(0.5),
    color: theme.palette.gray.darkerMedium,
    width: '18px',
    height: '18px'
  },
  styleText: {
    color: theme.palette.gray.darkerMedium
  },
  styleTextSubTitle: {
    color: theme.palette.gray.darker,
    fontSize: '14px',
    fontWeight: 500
  },
  styleSubText: {
    color: theme.palette.gray.darkerMedium,
    fontSize: '12px',
    fontWeight: 400
  },
  generalChip: {
    background: theme.palette.gray.lighter,
    color: theme.palette.gray.darker,
    fontSize: '14px',
    fontWeight: 400,
    marginLeft: theme.spacing(1)
  }
});

class InfoEmployeeDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // Props
      employee_id: props.employee_id,
      employee_email: props.employee_email,
      internal_verified: props.internal_verified,
      area_code: '',
      area_name: '',
      manager_code: '',
      manager_name: '',
      loadedEmployeeInfo: false,
      loadingEmployeeInfo: false
    };
  }

  componentDidMount() {
    if (this.props.open && !this.state.loadedEmployeeInfo) {
      this.loadEmployeeDetails();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.open !== this.props.open && this.props.open && !this.state.loadedEmployeeInfo) {
      this.loadEmployeeDetails();
    }
  }

  loadEmployeeDetails = () => {
    if (this.state.employee_id) {
      this.setState(
        {
          loadingEmployeeInfo: true
        },
        async () => {
          let api = new Api();

          const account_id = this.props.accountInfo.accountInfo.account_id;
          let filter = {
            where: {
              employee_id: this.state.employee_id,
              account_id: account_id
            }
          };

          try {
            const employeeData = await api.getAsync('AccountEmployeeNumbers', filter);

            if (employeeData) {
              const employee = employeeData.data[0];

              this.setState({
                area_code: employee.area_code || '',
                area_name: employee.area_name || '',
                manager_code: employee.manager_code || '',
                manager_name: employee.manager_name || '',
                loadedEmployeeInfo: true,
                loadingEmployeeInfo: false
              });
            } else {
              this.setState({
                loadingEmployeeInfo: false
              });
            }
          } catch (error) {
            console.error('Error fetching employee details:', error);

            this.setState({
              loadingEmployeeInfo: false
            });
          }
        }
      );
    }
  };

  createMainInfoEmployee = () => {
    const { classes } = this.props;
    const {
      employee_email,
      employee_id,
      internal_verified,
      area_code,
      area_name,
      manager_code,
      manager_name
    } = this.state;

    return (
      <>
        <Box>
          <Typography className={classes.styleSubText} style={{ fontWeight: '500' }}>
            {internal_verified ? (
              <FormattedMessage id="InfoEmployeeDetail.verifiedEmployee" />
            ) : (
              <FormattedMessage id="InfoEmployeeDetail.notVerifiedEmployee" />
            )}
          </Typography>
        </Box>

        <Box>
          <Box display="flex" alignItems="center">
            <Box display="flex">
              <Box>
                <Box mt={2}>
                  <Typography className={classes.styleSubText}>
                    <FormattedMessage id="InfoEmployeeDetail.email" />
                  </Typography>
                </Box>
                <Box mt={0.5}>
                  <Typography className={classes.styleSubText}>{employee_email}</Typography>
                </Box>
                <>
                  {employee_id && (
                    <>
                      <Box mt={2}>
                        <Typography className={classes.styleSubText}>
                          <FormattedMessage id="InfoEmployeeDetail.employeeId" />
                        </Typography>
                      </Box>

                      <Box mt={0.5}>
                        <Typography className={classes.styleSubText}>{employee_id}</Typography>
                      </Box>
                    </>
                  )}
                  {area_name && (
                    <>
                      <Box mt={2}>
                        <Typography className={classes.styleSubText}>
                          <FormattedMessage
                            id="InfoEmployeeDetail.area_name"
                            defaultMessage="Area"
                          />
                          :
                        </Typography>
                      </Box>

                      <Box mt={0.5}>
                        <Typography className={classes.styleSubText}>{area_name}</Typography>
                      </Box>
                    </>
                  )}
                  {area_code && (
                    <>
                      <Box mt={2}>
                        <Typography className={classes.styleSubText}>
                          <FormattedMessage
                            id="InfoEmployeeDetail.area_code"
                            defaultMessage="Area Code"
                          />
                          :
                        </Typography>
                      </Box>

                      <Box mt={0.5}>
                        <Typography className={classes.styleSubText}>{area_code}</Typography>
                      </Box>
                    </>
                  )}
                  {manager_name && (
                    <>
                      <Box mt={2}>
                        <Typography className={classes.styleSubText}>
                          <FormattedMessage
                            id="InfoEmployeeDetail.manager_name"
                            defaultMessage="Manager"
                          />
                          :
                        </Typography>
                      </Box>

                      <Box mt={0.5}>
                        <Typography className={classes.styleSubText}>{manager_name}</Typography>
                      </Box>
                    </>
                  )}
                  {manager_code && (
                    <>
                      <Box mt={2}>
                        <Typography className={classes.styleSubText}>
                          <FormattedMessage
                            id="InfoEmployeeDetail.manager_code"
                            defaultMessage="Manager Code"
                          />
                          :
                        </Typography>
                      </Box>

                      <Box mt={0.5}>
                        <Typography className={classes.styleSubText}>{manager_code}</Typography>
                      </Box>
                    </>
                  )}
                </>
              </Box>
            </Box>
          </Box>
        </Box>
      </>
    );
  };

  render() {
    const { classes } = this.props;

    return (
      <Box
        style={{
          width: '363px',
          maxHeight: '320px',
          borderRadius: '10px'
        }}
      >
        <Box
          style={{
            position: 'sticky',
            top: '0px',
            zIndex: '999',
            background: 'white'
          }}
        >
          <Box
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '8px'
            }}
          >
            <Box width="275px" display="flex" justifyContent="center">
              <Typography
                className={classes.styleSubText}
                style={{ display: 'flex', alignItems: 'center', fontWeight: '400' }}
              >
                <InfoOutlinedIcon className={classes.infoIcon} />
                <FormattedMessage id="InfoEmployeeDetail.infoTitle" />
              </Typography>
            </Box>
          </Box>
          <Divider style={{ margin: '0 1rem' }} />
        </Box>
        {this.state.loadingEmployeeInfo ? (
          <Box
            width="100%"
            display="flex"
            justifyContent="center"
            alignItems="center"
            style={{ height: '100px' }}
          >
            <CircularProgress color="secondary" size={24} />
          </Box>
        ) : (
          <Box
            display="flex"
            width="100%"
            style={{
              padding: '16px 24px'
            }}
          >
            <Box>{this.createMainInfoEmployee()}</Box>
          </Box>
        )}
      </Box>
    );
  }
}

InfoEmployeeDetail.propTypes = {
  accountInfo: PropTypes.object
};

const mapStateToProps = (state) => ({
  accountInfo: state.accountInfo
});

export default connect(
  mapStateToProps,
  null
)(injectIntl(withStyles(useStyles)(InfoEmployeeDetail)));
